import { ApostleSortBy } from '@apeiron/apostle'
import { SortByItem, SortInput } from '@apeiron/common'
import { OrbitalTrackSortBy } from '@apeiron/orbital'
import { PlanetSortBy } from '@apeiron/planet'
import { StarSortBy } from '@apeiron/star'
import { MenuItem, SelectChangeEvent, styled } from '@mui/material'
import { Select } from '@src/components/share/mui/Select'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

const StyledSelect = styled(Select)`
  min-width: 200px;
  min-height: 36px;
  ${props => props.theme.breakpoints.down('res480')} {
    min-width: 140px;
    min-height: 42px;
  }

  .MuiSelect-select {
    background-color: #161616;
  }

  & .MuiList-root {
    padding: 0 0px;
  }
`

const StyledMenuItem = styled(MenuItem)`
  :hover {
    background-color: #74797c33;
  }

  &.Mui-selected:hover {
    background-color: #74797c33;
  }

  &.Mui-selected {
    background-color: #343637;
  }
`

type SupportedSortBy =
  | PlanetSortBy
  | StarSortBy
  | OrbitalTrackSortBy
  | ApostleSortBy

const SortDropdown = <T extends SupportedSortBy>(props: Props<T>) => {
  const { className, items, onSelectChange, value } = props

  const { t } = useTranslation()

  const handleOnChange = useCallback(
    (event: SelectChangeEvent<unknown>) => {
      if (onSelectChange) {
        onSelectChange({ sortBy: event.target.value as T })
      }
    },
    [onSelectChange]
  )

  return (
    <StyledSelect
      inputProps={{
        'aria-label': 'sort-by-dropdown'
      }}
      className={className}
      onChange={handleOnChange}
      value={value.sortBy}
    >
      {items.map(item => {
        return (
          <StyledMenuItem key={item.id} value={item.value}>
            {t(item.nameId)}
          </StyledMenuItem>
        )
      })}
    </StyledSelect>
  )
}

type Props<T extends SupportedSortBy> = {
  className?: string
  items: SortByItem<T>[]
  value: SortInput<T>
  onSelectChange?: (value: SortInput<T>) => void
}

export default SortDropdown
